export default __webpack_public_path__ + "static/media/user-profile.94ac2d88.svg";